import { EpimsBaseEntityDto } from './epim-base.dto';
export class DeliveryTypeDto extends EpimsBaseEntityDto {

    DeliveryTypeId: string;
    DeliveryTypeName: string; 
    SubscriptionUserId: string;
    SubscriberId: string;
  

}